import { useTranslation } from 'react-i18next';
import { number, string } from 'yup';
import { InitiativeCountry } from 'basics/enums/country.enums';

const useStrategicImperativeFormSchema = () => {
  const { t } = useTranslation();
  const requiredLabel = t('form_errors_required');
  const invalidNumberLabel = t('form_errors_invalid_number');
  const countries = Object.keys(InitiativeCountry);

  return {
    title: string()
      .required(requiredLabel),
    description: string(),
    country: string().nullable().oneOf([...countries, null]),
    therapeuticArea: string().required(requiredLabel),
    year: number()
      .required(requiredLabel)
      .typeError(invalidNumberLabel),
  };
};

export default useStrategicImperativeFormSchema;
